export default "__VITE_ASSET__0b9e7066__"